import DataCacheRepository from './data-cache-repository';

window.addEventListener( 'nsAccountSignIn', event => {
	const cachedNsAccountSignIn = DataCacheRepository.getItem(
		DataCacheRepository.KEY_NS_ACCOUNT_SIGN_IN,
	);

	const accountSignInObject = {
		event: DataCacheRepository.KEY_NS_ACCOUNT_SIGN_IN,
		service_platform: cachedNsAccountSignIn ? cachedNsAccountSignIn.data : 'native',
	};
	const eventDetails = event && event.detail ? event.detail.signInStatus : null;
	const partyId = event && event.detail ? event.detail.partyId : null;

	if ( partyId ) {
		accountSignInObject.event_details = eventDetails || 'success';
		accountSignInObject.account_user_id = partyId;
	} else {
		accountSignInObject.event_details = eventDetails || 'Error not defined';
	}

	DataCacheRepository.removeItem(
		DataCacheRepository.KEY_NS_ACCOUNT_SIGN_IN,
		DataCacheRepository.STORAGE_LOCAL,
	);

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push( accountSignInObject );
} );
